export default function AuditLogActionLabel({ action }: { action: string }) {
  return <>{getActionLabel(action)}</>;
}

function getActionLabel(action: string) {
  switch (action) {
    case "set-document-category":
      return "Set Document Category";
    case "set-document-page-category":
      return "Set Page Category";
    case "upload-document":
      return "Upload Document";
    case "confirm-page-category-classification":
      return "Confirm Page Category Classification";
    case "reject-page-category-classification":
      return "Reject Page Category Classification";
    case "category.rename":
      return "Rename Category";
    case "category.delete":
      return "Delete Category";
    case "category.update-description":
      return "Update Category Description";
    default:
      return action;
  }
}
